import { render, staticRenderFns } from "./AgendaPointForm.vue?vue&type=template&id=29f644cb&scoped=true&"
import script from "./AgendaPointForm.vue?vue&type=script&lang=ts&"
export * from "./AgendaPointForm.vue?vue&type=script&lang=ts&"
import style0 from "./AgendaPointForm.vue?vue&type=style&index=0&id=29f644cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f644cb",
  null
  
)

export default component.exports